import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-minus",
  "use": "icon-minus-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\" id=\"icon-minus\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h44v44H0z\" /><path fill=\"currentColor\" d=\"M16 21h12v2H16z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol